export const continuationToken = {
  type: "string",
  minLength: 0,
  maxLength: 255
};
